import React from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';
import RestartDialogBody from '../RestartDialogBody';

const RestartDialog = ({ onClose, onAccept, ...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { onClose }
        cancelButton={{
            action: onClose,
            label: 'NO, CANCEL'
        }}
        acceptButton={{
            action: onAccept,
            label: 'YES, RESTART'
        }}
        header="Do you confirm  restart approval process?"
        body={<RestartDialogBody />}
    />;

export default RestartDialog;